import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./components/ui/common.css";
import "./components/ui/box.css";
import App from './components/app/app.js';
import { BrowserRouter as Router } from "react-router-dom";

//const root = ReactDOM.createRoot(document.getElementById('root'));
ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
